import graphqlClient from '~/graphql/graphqlClient';

export interface MutationUpgradeAttributeArgs {
  playerId: string;
  heroHandle: string;
  attributeHandle: string;
  heroBuildId: string;
}

export interface AttributeChangeResult {
  heroHandle: string;
  heroBuild: any;
}

const mutation = `
mutation UpgradeAttribute(
  $playerId: String!
  $heroHandle: String!
  $attributeHandle: String!
  $heroBuildId: String!
) {
  upgradeAttribute(
    playerId: $playerId
    heroHandle: $heroHandle
    attributeHandle: $attributeHandle
    heroBuildId: $heroBuildId
  ) {
    heroHandle
    heroBuild
  }
}`;

export default async function mutationUpgradeAttribute(args: MutationUpgradeAttributeArgs) {
  return await graphqlClient.request<AttributeChangeResult>('upgradeAttribute', mutation, args);
}
